"use client";

import { motion } from "framer-motion";
import type { ReactNode } from "react";
import { cn } from "~/lib/utils";

export function HomeSection({
  id,
  children,
  className,
  tone = "white",
}: {
  id?: string;
  children: ReactNode;
  className?: string;
  tone?: "white" | "slate" | "brand";
}) {
  return (
    <section
      id={id}
      className={cn(
        "relative scroll-mt-24 px-4 py-20 sm:px-6 sm:py-28 lg:px-8",
        tone === "white" && "bg-white",
        tone === "slate" && "bg-slate-50",
        tone === "brand" && "bg-slate-950 text-white",
        className,
      )}
    >
      <div className="relative mx-auto max-w-6xl">{children}</div>
    </section>
  );
}

export function HomeEyebrow({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p
      className={cn(
        "text-xs font-semibold uppercase tracking-[0.16em] text-[#4f81bd]",
        className,
      )}
    >
      {children}
    </p>
  );
}

export function HomeHeading({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <h2
      className={cn(
        "mt-3 text-balance text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl",
        className,
      )}
    >
      {children}
    </h2>
  );
}

export function HomeLead({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <p className={cn("mt-4 max-w-2xl text-lg leading-relaxed text-slate-600", className)}>
      {children}
    </p>
  );
}

export function FadeIn({
  children,
  className,
  delay = 0,
}: {
  children: ReactNode;
  className?: string;
  delay?: number;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.45, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
